/**
 * Marks a session that a human started by hand via `/a7y-<kind>-trigger`
 * rather than the cron.
 *
 * Deliberately renders nothing for a scheduled run: the overwhelming majority
 * are scheduled, so a "Scheduled" chip on every row would be noise that buries
 * the one case worth spotting. Nothing is also rendered when provenance is
 * unknown (`null`) — sessions predating `auto_session_log.trigger_source` —
 * because claiming a run was scheduled when we don't know is worse than saying
 * nothing.
 */
export function TriggerBadge({ manuallyTriggered }: { manuallyTriggered: boolean | null }) {
  if (manuallyTriggered !== true) return null;
  return (
    <span
      className="rounded-full bg-violet-100 px-1.5 py-0.5 text-[10px] font-medium whitespace-nowrap text-violet-800 dark:bg-violet-950 dark:text-violet-300"
      title="Started by hand via /a7y-<kind>-trigger, not by the schedule"
    >
      Manual
    </span>
  );
}
